type RadioOption = {
	value: string;
	label: string;
};

type RadioGroupProps = {
	label: string;
	name: string;
	options: RadioOption[];
	value: string;
	onChange: (value: string) => void;
};

export function RadioGroup({
	label,
	name,
	options,
	value,
	onChange,
}: RadioGroupProps) {
	return (
		<fieldset className="pf-radio-group">
			<legend className="pf-radio-group__label">{label}</legend>
			<div className="pf-radio-group__options">
				{options.map((option) => (
					<label key={option.value} className="pf-radio-group__option">
						<input
							type="radio"
							name={name}
							value={option.value}
							checked={value === option.value}
							onChange={() => onChange(option.value)}
						/>
						<span>{option.label}</span>
					</label>
				))}
			</div>
		</fieldset>
	);
}
